import { Component, OnInit } from '@angular/core';
import { CoursesService } from 'src/providers/courses.service';


@Component({
  selector: 'app-offline-center',
  templateUrl: './offline-center.component.html',
  styleUrls: ['./offline-center.component.scss']
})
export class OfflineCenterComponent implements OnInit {

  constructor(public coursesService: CoursesService){}

  ngOnInit(): void {
    this.getFranchiseData()
  }

  getFranchiseData(){
    this.coursesService.getFranchiseData().subscribe(res=>{
      console.log(res)
    })
  }

}